import { OptionalExtraPresenter } from 'presenters'
import { BookingPresenter } from 'shared/presenters/BookingPresenter'
import { definedNotNull } from 'shared/presenters/presenter'
import formatOptionalExtras from 'shared/helpers/formatOptionalExtraData/formatOptionalExtras'

interface determineOptionalExtrasFromActivityVoucherProps {
  bookingFromActivityVoucher?: BookingPresenter | null
  optionalExtraPresenter?: OptionalExtraPresenter[]
}

const determineOptionalExtrasFromActivityVoucher = ({
  bookingFromActivityVoucher,
  optionalExtraPresenter
}: determineOptionalExtrasFromActivityVoucherProps) => {
  const optionalExtrasIdsAndQuantitiesFromActivityVoucher =
    bookingFromActivityVoucher?.chosen_optional_extras

  const optionalExtraQuantitiesFromActivityVoucher =
    optionalExtrasIdsAndQuantitiesFromActivityVoucher
      ?.filter(item => item.optional_extra?.id)
      .map(item => ({
        [definedNotNull(item.optional_extra?.id)]: item.quantity
      }))

  const optionalExtrasIdQuantitiesFromActivityVoucher =
    optionalExtraQuantitiesFromActivityVoucher &&
    Object.assign({}, ...optionalExtraQuantitiesFromActivityVoucher)

  const optionalExtrasNamesAndQuantitiesFromActivityVoucher =
    formatOptionalExtras(
      optionalExtraPresenter,
      optionalExtrasIdQuantitiesFromActivityVoucher
    )

  return optionalExtrasNamesAndQuantitiesFromActivityVoucher
}

export default determineOptionalExtrasFromActivityVoucher
